import { useRef, forwardRef } from 'react';
import styles from './FJFileUpload.module.less';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
const FJFileUpload = (props, refs) => {
    const { accept = UPLOAD_FILE_TYPE_NO_GIF, onUpload, children, className, multiple = false, onClick } = props;
    const inputRef = useRef(null);
    const _onChange = e => {
        if (multiple) {
            const files = e.target.files;
            onUpload(files);
        } else {
            const file = e.target.files[0];
            onUpload(file);
        }
        e.target.value = null;
    };

    const _onclick = e => {
        if (onClick) onClick();
        else inputRef.current.click();
    };
    return (
        <div className={className} onClick={_onclick}>
            {children}
            <input
                multiple={multiple}
                type='file'
                ref={inputRef}
                accept={accept}
                className={styles.input}
                onChange={_onChange}
            />
        </div>
    );
};

export default forwardRef(FJFileUpload);
